import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";

import routes from "./routes";
import module from "./module";
import store from "../store";

Vue.use(VueRouter);
for (var key in module) {
    routes.push(module[key]);
}

const router = new VueRouter({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: routes
})
router.beforeEach((to, from, next) => {   
    const token = localStorage.getItem('token');
    if (to.matched.some(record => record.meta.auth) == true) { 
      if(token == null) 
        {
           next({
                path: '/auth/login'
              })          

        } else {
          next()
        }
    } else {
      next();
    }
    
});
export default router




// WEBPACK FOOTER //
// ./src/router/index.js